"use strict";

exports.__esModule = true;
exports.USER_ID_TYPE_SITE_MEMBER = exports.USER_ID_TYPE_USER = exports.USER_ID_TYPE_OWNER = void 0;
var USER_ID_TYPE_OWNER = 'owner';
exports.USER_ID_TYPE_OWNER = USER_ID_TYPE_OWNER;
var USER_ID_TYPE_USER = 'user';
exports.USER_ID_TYPE_USER = USER_ID_TYPE_USER;
var USER_ID_TYPE_SITE_MEMBER = 'sitemember';
exports.USER_ID_TYPE_SITE_MEMBER = USER_ID_TYPE_SITE_MEMBER;